import { useContext, useEffect } from "react";

import { StateContext } from "../../context/globalContext/context";
import { iGlobalContext } from "../../context/globalContext/interface";
import {
  subscribeIntentChannel,
  unsubscribeIntentChannel,
} from "../../services/intent/intentChannel";
import { disconnectPusher, initPusher } from "../../services/pusher/pusherConnection";
import {
  subscribeSearchProgressChannel,
  unsubscribeSearchProgressChannel,
} from "../../services/searchProgress/searchProgressChannel";
import { searchProgressDevHelper } from "../../services/searchProgress/searchProgressDemo";
import { getSessionId } from "../../utils/sessionId";

// Owns the single shared Pusher connection. On login: open the socket, then let
// each independent feature subscribe its OWN channel (intent + searchProgress).
// On logout: unsubscribe both + disconnect. Renders nothing. Feature modules
// never build the connection — they only subscribe through getPusher().
export default function PusherBootstrap(): null {
  const { accessJWT, userInfo } = useContext(StateContext) as iGlobalContext;
  const userId = userInfo?.id;

  // Dev console helper for the search-progress stream (window.__searchProgress).
  useEffect(() => {
    if (import.meta.env.MODE !== "development") return;
    (window as unknown as { __searchProgress: typeof searchProgressDevHelper }).__searchProgress =
      searchProgressDevHelper;
    return () => {
      delete (window as unknown as { __searchProgress?: typeof searchProgressDevHelper }).__searchProgress;
    };
  }, []);

  useEffect(() => {
    if (!userId || !accessJWT) return;
    const pusher = initPusher(getSessionId(), String(userId), accessJWT);
    if (!pusher) return;
    subscribeIntentChannel();
    subscribeSearchProgressChannel();
    return () => {
      unsubscribeIntentChannel();
      unsubscribeSearchProgressChannel();
      disconnectPusher();
    };
  }, [userId, accessJWT]);

  return null;
}
